import React from "react";

import { SvgIconComponent } from "@material-ui/icons";
import { SvgIconProps } from "@material-ui/core";

const CheckMark: SvgIconComponent = (props: SvgIconProps) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.231 28.9624L38.57 8.62341L44.1591 14.2125L18.231 40.1405L4.15906 26.0686L9.74811 20.4796L18.231 28.9624ZM18.9298 33.8528L18.2312 34.5514L17.5325 33.8528L18.2312 34.5514L18.9298 33.8528Z"
      fill="black"
    />
  </svg>
);

export default CheckMark;
